import React from 'react';

import useApiService from '../../services/useApiService';

const defaultTeams = [
    "Leadership Team",
    "Discovery Management Team",
    "Camp Support Team",
    "Emergency Management Team",
    "Field Supervisors",
    "Field Team",
    "International Travelers",
    "Mine Team",
    "Medical Team",
    "Office Team",
    "Professional Drivers Team",
    "SHEC Team"
]

const withTeams = (Component, onMount = true) => {
  return (props) => {
    const payload = { params: { context: 'tags' } };
    const [{ isLoading: isLoadingTeams, response: assignedTeams }, getAssignedTeams] = useApiService({ url: `/tags`, payload: payload, onMount, defaultResponse: []});
    const assignedTeamsList = assignedTeams.map((team)=>{ return team.name });
    const defaultTeamOptions = [...new Set(defaultTeams.concat(assignedTeamsList))];
    const componentProps = {...props, isLoadingTeams, defaultTeamOptions, assignedTeams, getAssignedTeams }
    return <Component {...componentProps} />;
  };
};

export default withTeams;


// WEBPACK FOOTER //
// ./src/views/components/with_teams.js